(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/jackpot.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/jackpot.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Jackpot = Backbone.Model.extend({
    initialize: function() {
      var jackpotArr = svs.tipset.data.jackpot
          ? svs.tipset.data.jackpot.split(' ')
          : [],
        valArr = [],
        jackpott,
        jackpottNumberAsString,
        numericJackpot,
        currentJackpotInMillions,
        currentJackpotFormatted,
        currentJackpot;

      for (var i = 0; i < jackpotArr.length; i++) {
        var val = svs.utils.format.CurrencyFromJupiterString(jackpotArr[i]);
        if (!isNaN(val)) {
          valArr.push(jackpotArr[i]);
        }
      }

      jackpottNumberAsString = valArr.join('');
      jackpott = svs.utils.format.CurrencyFromJupiterString(
        jackpottNumberAsString
      );
      numericJackpot =
        svs.tipset.data.jackpot && svs.tipset.data.jackpot.indexOf('milj') > -1
          ? jackpott * 1000000
          : jackpott;

      currentJackpotInMillions = svs.utils.format.CurrencyInMillions(
        numericJackpot == '' ? '0' : numericJackpot
      );
      currentJackpotFormatted =
        'ca ' +
        (numericJackpot > 999999
          ? currentJackpotInMillions + ' milj kr'
          : svs.utils.format.Currency(numericJackpot, false) + ' kr');
      currentJackpot = numericJackpot || 0;

      this.set('currentJackpotInMillions', currentJackpotInMillions);
      this.set('currentJackpotFormatted', currentJackpotFormatted);
      this.set('currentJackpot', currentJackpot);
      svs.tipset.collections.draws.setJackpot(this);
    }
  });
})(Backbone, _, svs);

 })(window);